import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useParams, useRouteMatch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import * as Action from '../../actions/EventManagement';

import Typography from '../Typography/CustomTypography';

import styles from '../../assets/jss/components/adminHeaderStyle';

const useStyles = makeStyles(styles);

const AdminHeader = (props) => {
    const {
        routes, eventName, isUser, eventNameForUser, displayBackGroundImage,
    } = props;
    const classes = useStyles(props);
    const match = useRouteMatch();
    const params = useParams();

    const makeBrand = () => {
        if (!_.isEmpty(routes)) {
            const matchRouter = routes.find((route) => `${route.layout ? route.layout : ''}${route.param ? route.param : ''}${route.path}` === match.path);
            if (!_.isEmpty(matchRouter)) {
                return matchRouter.name;
            }
            return '';
        }
        return '';
    };

    return (
        <AppBar className={isUser ? classes.userAppBar : classes.appBar}>
            <Toolbar className={classes.container}>
                <div className={classes.flex}>
                    {isUser ? (
                        <Typography bold variant="h2" className={displayBackGroundImage ? classes.userText : classes.noImageText}>
                            {!_.isEmpty(params) ? eventNameForUser : makeBrand()}
                        </Typography>
                    )
                        : (
                            <Typography bold variant="h4" color="info">
                                {!_.isEmpty(params) ? eventName : makeBrand()}
                            </Typography>
                        )}

                </div>
                {/* TODO add drawer mobile app */}
            </Toolbar>
        </AppBar>
    );
};

AdminHeader.defaultProps = {
    routes: [],
    eventName: '',
    eventNameForUser: '',
    isUser: false,
    displayBackGroundImage: false,
};

AdminHeader.propTypes = {
    routes: PropTypes.oneOfType([() => null, PropTypes.array]),
    eventName: PropTypes.string,
    eventNameForUser: PropTypes.string,
    isUser: PropTypes.bool,
    displayBackGroundImage: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    eventName: state.eventManagement.infoEvent.data && state.eventManagement.infoEvent.data.name,
    eventNameForUser: state.registration.registrationViewer.data.name,
});

const mapDispatchToProps = (dispatch) => ({
    fetchInfoEvent: (param) => dispatch(Action.GetInfoEventRequested(param)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdminHeader);
